(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frostbreak-fit"] && !Shopify.designMode) return;
  try {
    
 if(!customElements.get('frostbreak-fit')){
  customElements.define('frostbreak-fit',class extends HTMLElement{
   connectedCallback(){
    this.abort=new AbortController();
    this.querySelector('[data-fit-guide]')?.addEventListener('click',event=>{
     const dialog=document.querySelector('.fb-pdp-size-dialog');
     if(dialog&&typeof dialog.showModal==='function'){event.preventDefault();if(!dialog.open)dialog.showModal();}
    },{signal:this.abort.signal});
   }
   disconnectedCallback(){this.abort?.abort();}
  });
 }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frostbreak-gloves-pdp"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('frostbreak-gloves-pdp')) customElements.define('frostbreak-gloves-pdp', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const opts = {signal:this.abort.signal};
      const slides = [...this.querySelectorAll('[data-slide]')];
      const thumbs = [...this.querySelectorAll('[data-thumb]')];
      let index = 0;
      const show = next => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide,i) => slide.hidden = i !== index);
        thumbs.forEach((thumb,i) => thumb.setAttribute('aria-pressed',String(i === index)));
        thumbs[index]?.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
      };
      thumbs.forEach((thumb,i) => thumb.addEventListener('click',()=>show(i),opts));
      this.querySelector('[data-next]')?.addEventListener('click',()=>show(index+1),opts);
      this.querySelector('.fb-pdp-thumbnails')?.addEventListener('keydown',event=>{
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        show(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length-1 : index+(event.key === 'ArrowRight'?1:-1));
        thumbs[index]?.focus();
      },opts);
      const dialog = this.querySelector('dialog');
      this.querySelector('[data-size-open]')?.addEventListener('click',()=>dialog.showModal(),opts);
      this.querySelector('[data-size-close]')?.addEventListener('click',()=>dialog.close(),opts);
      dialog.addEventListener('click',event=>{if(event.target === dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}},opts);
      const money = cents => new Intl.NumberFormat(this.dataset.locale || 'de-DE',{style:'currency',currency:this.dataset.currency || 'EUR'}).format(cents/100);
      const updateMainPrice = (price,compare) => {
        this.querySelector('[data-main-price]').textContent = money(price);
      };
      const update = () => {
        const checked=this.querySelector('[data-offer-radio]:checked');
        const card=checked?.closest('.fb-pdp-offer');
        const select=card?.querySelector('[data-offer-variant]') || this.querySelector('[data-main-variant]');
        if(!select) return;
        const option=select.selectedOptions[0];if(!option)return;
        const quantity=Number(checked?.dataset.quantity || 1);
        const price=Number(option.dataset.price),compare=Number(option.dataset.compare);
        const variantField=this.querySelector('[data-cart-variant]');if(variantField){variantField.value=option.value;variantField.disabled=!!this.querySelector('[data-main-variant]');}
        const quantityField=this.querySelector('[data-cart-quantity]');if(quantityField)quantityField.value=quantity;
        const button=this.querySelector('[data-add]');if(button){button.disabled=option.dataset.available !== 'true';button.textContent=button.disabled?button.dataset.unavailable:button.dataset.label;}
        if(card){card.querySelector('[data-offer-price]').textContent=money(price*quantity);}
        const stock=this.querySelector('[data-stock]');if(stock)stock.hidden=option.dataset.available !== 'true';
        updateMainPrice(price,compare);
      };
      this.querySelectorAll('[data-offer-radio],[data-offer-variant],[data-main-variant]').forEach(control=>control.addEventListener('change',update,opts));
      update();
    }
    disconnectedCallback(){this.abort?.abort();clearInterval(this.timer);}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frostbreak-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('frostbreak-header')) {
    customElements.define('frostbreak-header', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const toggle = this.querySelector('.fb-menu-toggle');
        const nav = this.querySelector('.fb-nav');
        toggle.hidden = false;
        this.dataset.ready = '';
        toggle.addEventListener('click', () => {
          const open = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', String(open));
          nav.toggleAttribute('data-open', open);
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const detail = event.target.closest('details[open]');
          if (detail) { detail.open = false; detail.querySelector('summary').focus(); }
          else if (nav.hasAttribute('data-open')) { nav.removeAttribute('data-open'); toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
        }, options);
        document.addEventListener('click', (event) => {
          this.querySelectorAll('details[open]').forEach(detail => { if (!detail.contains(event.target)) detail.open = false; });
        }, options);
        const clock = this.querySelector('[data-countdown]');
        if (clock) {
          const raw = clock.dataset.countdown;
          const end = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(raw) ? Date.parse(raw) : NaN;
          const tick = () => {
            const remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
            if (!Number.isFinite(end) || remaining === 0) {
              clock.hidden = true;
              if (Number.isFinite(end) && clock.dataset.expiry === 'hide_bar') this.querySelector('[data-sale]').hidden = true;
              clearInterval(this.timer);
              return;
            }
            const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
            for (const [key, value] of Object.entries(values)) clock.querySelector(`[data-time="${key}"]`).textContent = String(value).padStart(2, '0');
            clock.hidden = false;
          };
          this.timer = setInterval(tick, 1000); tick();
        }
        this.observer = new ResizeObserver(() => {
          document.body.style.setProperty('--header-height', `${this.querySelector('.fb-row').offsetHeight}px`);
          document.body.style.setProperty('--header-group-height', `${document.getElementById('header-group')?.offsetHeight || this.offsetHeight}px`);
        });
        this.observer.observe(this);
      }
      disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frostbreak-pdp"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('frostbreak-pdp')) customElements.define('frostbreak-pdp', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const opts = {signal:this.abort.signal};
      const slides = [...this.querySelectorAll('[data-slide]')];
      const thumbs = [...this.querySelectorAll('[data-thumb]')];
      let index = 0;
      const show = next => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide,i) => slide.hidden = i !== index);
        thumbs.forEach((thumb,i) => thumb.setAttribute('aria-pressed',String(i === index)));
        thumbs[index]?.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
      };
      thumbs.forEach((thumb,i) => thumb.addEventListener('click',()=>show(i),opts));
      this.querySelector('[data-next]')?.addEventListener('click',()=>show(index+1),opts);
      this.querySelector('.fb-pdp-thumbnails')?.addEventListener('keydown',event=>{
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        show(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length-1 : index+(event.key === 'ArrowRight'?1:-1));
        thumbs[index]?.focus();
      },opts);
      const dialog = this.querySelector('dialog');
      this.querySelector('[data-size-open]')?.addEventListener('click',()=>dialog.showModal(),opts);
      this.querySelector('[data-size-close]')?.addEventListener('click',()=>dialog.close(),opts);
      dialog.addEventListener('click',event=>{if(event.target === dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}},opts);
      const money = cents => new Intl.NumberFormat(this.dataset.locale || 'de-DE',{style:'currency',currency:this.dataset.currency || 'EUR'}).format(cents/100);
      const updateMainPrice = (price,compare) => {
        this.querySelector('[data-main-price]').textContent = money(price);
      };
      const update = () => {
        const checked=this.querySelector('[data-offer-radio]:checked');
        const card=checked?.closest('.fb-pdp-offer');
        const select=card?.querySelector('[data-offer-variant]') || this.querySelector('[data-main-variant]');
        if(!select) return;
        const option=select.selectedOptions[0];if(!option)return;
        const quantity=Number(checked?.dataset.quantity || 1);
        const price=Number(option.dataset.price),compare=Number(option.dataset.compare);
        const variantField=this.querySelector('[data-cart-variant]');if(variantField){variantField.value=option.value;variantField.disabled=!!this.querySelector('[data-main-variant]');}
        const quantityField=this.querySelector('[data-cart-quantity]');if(quantityField)quantityField.value=quantity;
        const button=this.querySelector('[data-add]');if(button){button.disabled=option.dataset.available !== 'true';button.textContent=button.disabled?button.dataset.unavailable:button.dataset.label;}
        if(card){card.querySelector('[data-offer-price]').textContent=money(price*quantity);}
        const stock=this.querySelector('[data-stock]');if(stock)stock.hidden=option.dataset.available !== 'true';
        updateMainPrice(price,compare);
      };
      this.querySelectorAll('[data-offer-radio],[data-offer-variant],[data-main-variant]').forEach(control=>control.addEventListener('change',update,opts));
      update();
    }
    disconnectedCallback(){this.abort?.abort();clearInterval(this.timer);}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
